import styled from 'styled-components'
import { mediaQueries } from 'plugins/device'
import {
  Button as BuiButton,
  Link as BuiLink,
  TextHeadline3,
  TextBody,
  IconClose,
  Modal,
  IconIllustrativeInfoAlt,
  colors,
} from '@blocket/blocket-ui'

export const WarningModal = styled(Modal)`
  /* prevent default behavior of Modal to expand over the screen, up to "medium" */
  @media (max-width: 767px) {
    max-width: 550px;
    height: auto;
    bottom: 0;
    top: initial;
    left: 50%;
    transform: translate(-50%);
    border-radius: 10px 10px 0 0;
  }
  @media ${mediaQueries.medium} {
    width: auto;
    border-radius: 4px;
  }
`

export const WarningIcon = styled(IconIllustrativeInfoAlt)`
  margin-bottom: 8px;
  height: 60px;
  width: 50px;
  align-self: flex-start;
  @media ${mediaQueries.medium} {
    margin-bottom: 24px;
    height: 64px;
    width: 64px;
  }
`

export const IconWrapper = styled.div`
  margin-bottom: 10px;
`

export const ShieldIcon = styled.img`
  margin-bottom: 8px;
  height: 56px;
  width: auto;
  align-self: flex-start;
  @media ${mediaQueries.medium} {
    margin-bottom: 24px;
    height: 64px;
  }
`

export const Text = styled(TextBody)`
  max-width: 340px;
  font-size: 15px;
  line-height: 20px;
`

export const CloseIcon = styled(IconClose)`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  @media ${mediaQueries.medium} {
    top: 24px;
    right: 24px;
  }
`

export const Content = styled.div`
  position: relative;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${mediaQueries.medium} {
    padding: 32px;
  }
`

export const Label = styled(TextHeadline3)`
  margin-bottom: 8px;
`

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const Link = styled(BuiLink)`
  cursor: pointer;
  display: flex;
  text-decoration: underline;
  &:hover {
    color: ${colors.blue700};
  }
`

export const ReadMoreLink = styled(Link)`
  font-size: 15px;
  line-height: 20px;
`

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  & > div:first-child {
    margin-bottom: 8px;
  }
  @media ${mediaQueries.medium} {
    flex-direction: row-reverse;
    ${({ singleButton }) => singleButton && 'align-self: flex-end'}
  }
`

export const Button = styled(BuiButton)`
  min-width: 164px;
  & > button {
    padding: 0 24px;
  }
`

export const SecondaryButton = styled(Button)`
  & > button {
    padding: 0 42px;
  }
`

export const PrimaryButton = styled(Button)`
  & > a {
    padding: 0 24px;
  }
  @media ${mediaQueries.medium} {
    margin-left: 16px;
  }
`
